<template>
  <div class="profile-wrapper emb-card pa-4">
    <h4>{{SubscribeSection.Newsletter_Label}}</h4>
    <hr />
    <div class="pt-4" v-if="newsletterDetails !== '' ">
      <div class="address-Boxs">
        <div
          class="col-xs-12 col-sm-12 col-lg-12 newsletter-div"
          v-for="(data,index) in newsletterDetails"
          :key="index"
        >
          <div class="col-xs-12 col-sm-12 col-lg-6 newslettertxt">{{data.keyword1}}</div>
          <!-- <div class="col-xs-12 col-sm-12 col-lg-4 newslettertxt">{{data.type}}</div> -->
          <div class="col-xs-12 col-sm-12 col-lg-6 newslettertxt">
            <span>
              <v-btn
                class="accent"
                @click.prevent="UnsubcribeData(data.id)"
              >{{SubscribeSection.Unsubscribe_Label}}</v-btn>
            </span>
          </div>
        </div>
        <!-- <h6 v-if="!address.bool1"><a href="#" @click.prevent="setDefaultShippingAddress(address.id)" >{{'Set Default'}}</a></h6> -->
      </div>
    </div>
    <div class="pt-4" v-else>{{SubscribeSection.Not_Found_Label}}</div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../services/utils/cms-helper";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";

Vue.use(VueToast, { position: "top-right", duration: 4000 });
export default {
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
  },
  data() {
    return {
      cmsRequestFunctions: null,
      SubscribeSection: "",
      profileInfoSection: "",
      newsletterDetails: "",
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.readNewsletterData();
    this.getNewsletterData();
  },
  watch: {
    selectedLocale: function () {
      this.readNewsletterData();
      this.getNewsletterData();
    },
  },
  methods: {
    readNewsletterData: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      var userData = JSON.parse(user);
      var loginDetails = userData.user_data;
      var email = loginDetails.loginId;
      var filterValue = "type='Newsletter' AND keyword2='" + email + "'";
      var allData = await this.cmsRequestFunctions.getDbDataTableValue(
        filterValue,
        "date1"
      );
      if (
        allData != undefined &&
        allData.data != undefined &&
        allData.status == 200
      ) {
        self.newsletterDetails = allData.data.data;
        //console.log('newsletter',self.newsletterDetails);
      } else {
        console.log("error:", allData);
        self.newsletterDetails = "";
      }
    },
    getNewsletterData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "18 Home Page/18 Home Page/18 Home Page.ftl",
        lang: language,
        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var SubscribeArea = self.cmsRequestFunctions.pluck(
              "Subscribe_Section",
              res.area_List
            );
            self.SubscribeSection = self.cmsRequestFunctions.getAllMapData(
              SubscribeArea[0].component
            );
            //console.log ('ssubscribe',self.SubscribeSection);
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },

    UnsubcribeData: async function (newsLetterId) {
      var self = this;
      self.isLoading = true;
      var allData = await self.cmsRequestFunctions.deleteDbDataTableValue(
        newsLetterId
      );
      if (
        allData != undefined &&
        allData.data != undefined &&
        allData.status == 200
      ) {
        // Vue.$toast.success(self.cmsRequestFunctions.getValidationMsgByCode('M027'));
        this.$snotify.success(
          self.cmsRequestFunctions.getValidationMsgByCode("M027"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
          }
        );
        //location.reload();
        setTimeout(function () {
          self.readNewsletterData();
        }, 500);
      } else {
        console.log("error:", allData);
      }
    },
  },
};
</script>